import { useRef } from 'react'
import { InviteLink } from '@weblite/ts-action/hall'
import { PageWithAppBar } from '$common/page-with-app-bar'
import { AppBarBackTitleConfirm } from '$common/app-bar/app-bar-back-title-confirm'
import { createNewInviteLink, editInviteLink } from '$logic/hall'
import { closeCreateInviteLink } from '$logic/router'
import { t } from '$i18n'
import { getRoom } from '$logic/room'
import {
  CreateInviteLinkTimeInput,
  CreateInviteLinkTimeInputApiType,
} from './components/create-invite-link-time-input'
import {
  CreateInviteLinkUsageInput,
  CreateInviteLinkUsageInputApiType,
} from './components/create-invite-link-usage-input'

interface Props {
  roomId: string
  inviteLink?: InviteLink
  isCreation: boolean
}

export function ManageInviteLink({ roomId, inviteLink, isCreation }: Props) {
  const { link, expiresAt, usageLimit } = inviteLink ?? {}

  const timeRef = useRef<CreateInviteLinkTimeInputApiType>(null)
  const usageRef = useRef<CreateInviteLinkUsageInputApiType>(null)

  const onConfirm = async () => {
    const { current: timeApi } = timeRef
    const { current: usageApi } = usageRef
    if (!timeApi || !usageApi) return

    const time = timeApi.getValue()
    const usage = usageApi.getValue()
    if (isCreation) {
      const room = await getRoom(roomId)
      analite('CHAT_CREATE_LINK', { type: room?.type })
      await createNewInviteLink(roomId, time, usage)
    } else if (link) await editInviteLink(roomId, link, time, usage)
    closeCreateInviteLink()
  }

  // const onRevoke = async () => {
  //   // TODO modal
  //   await revokeInviteLink(roomId, link)
  // }

  return (
    <PageWithAppBar
      appBar={
        <AppBarBackTitleConfirm
          onBack={closeCreateInviteLink}
          onConfirm={onConfirm}
          confirmDisabled={false}
          title={
            isCreation
              ? t('inviteLinks.common.createLink')
              : t('inviteLinks.common.editLink')
          }
        />
      }
    >
      <CreateInviteLinkTimeInput
        ref={timeRef}
        expiresAt={expiresAt ? new Date(expiresAt) : undefined}
      />
      <CreateInviteLinkUsageInput ref={usageRef} usageLimit={usageLimit} />
    </PageWithAppBar>
  )
}
